import React, {useEffect, useState} from 'react';
import PropTypes from "prop-types";
import Radio from "../common_elements/Radio";
import Select from "../common_elements/Select";
import {useDispatch, useSelector} from "react-redux";
import ExceptionMessage from "../common_elements/ExceptionMessage";
import {updateModuleSelections} from "../../store/product/productElementsSlice";

const ElementModuleOptionsSelection = (props) => {
    const [showException, setShowException] = useState(false);
    const [messages, setMessages] = useState([]);
    const [exceptionLeft, setExceptionLeft] = useState(0);
    const options = props.element.product_attributes.filter(pa => pa.per_module)
    const selections = props.element.attribute_selections
    const disabledFields = useSelector(state => state.disabledFieldsReducer.disabledElementFields);
    const dispatch = useDispatch();
    const styles = {
        list: {
            listStyleType: 'none',
            display: 'inline-block',
            margin: '0 7px',
        }
    }

    const handleAttribute = (attribute, value, manual) => {
        dispatch(updateModuleSelections(props.elements, props.element.section_number, attribute, value));
    }

    const handleDisabledClick = (option, e) => {
        setShowException(true)
        const mouseX = e.pageX;
        const matchingField = disabledFields[props.element.elementKey].find(obj => obj.id == option.id);
        const message = matchingField.messages;
        setExceptionLeft(mouseX);
        setMessages(message)
    }

    const getDisabledSelections = (attribute) => {
        if(disabledFields == null || disabledFields[props.element.elementKey] == null){
            return [];
        }
        const matchingField = disabledFields[props.element.elementKey].find(obj => obj.id == attribute.id);
        return matchingField ? matchingField.disabledSelections : [];
    }

    const shouldDisableSelect = (attribute, disabled) => {
        const selections = attribute.values.split(",");
        return selections.length == disabled.length;
    }

    const getFields = () => {
        let fields = [];
        options.forEach(function(el, index){
            // find current selection for this attribute or option
            // get the value of the selection
            const disabledSelections = getDisabledSelections(el);
            const matchingAttributeSelection = selections.find(sel => sel.id == el.id);
            const currentVal = matchingAttributeSelection ? matchingAttributeSelection.selection : ""
            const messages = [];
            const shouldDisable = shouldDisableSelect(el, disabledSelections);
            const inputKey = el.id + '-' + currentVal;
            if(el.values.length > 1) {
                // check if this field should be disabled based on exceptions
                // const shouldDisable = false// shouldDisableSelect(el, disabledSelections);
                fields.push(
                    <li key={el.id} style={styles.list}>
                        <label className={"label_select " + (shouldDisable ? 'disabled':'enabled')} title={messages.join(', ')}>
                            {el.name}
                            <Select attributes={el} currentValue={currentVal} hasEmptyField={'true'} fieldId={el.sku_order} propType={'ATTRIBUTE'}
                                    disabledSelections={disabledSelections}
                                    onClick={(e) => handleDisabledClick(el, e)} onChange={() => hideExceptionMessage()}
                                    handleAttribute={(value) => handleAttribute(el, value, true)}
                            />
                        </label>
                    </li>

                );
            }else{
                fields.push(
                    <li key={`${el.id}-inputKey`}  title={messages.join(', ')} style={styles.list}>
                        <Radio attributes={el} currentValue={currentVal} checkType={'checkbox'} fieldId={el.sku_order} propType={'ATTRIBUTE'}
                               disabledSelections={disabledSelections}
                               handleAttribute={(value) => handleAttribute(el, value, true)}
                               onClick={(e) => handleDisabledClick(el, e)}
                               key={inputKey}
                               styles={{margin: '0 7px'}}
                        />
                    </li>
                );
            }
        }, this);

        return fields;
    }

    const exceptionMessage = () => {
        if(!showException || messages.length == 0) {
            return
        }

        return <ExceptionMessage message={messages} posTop={50} posLeft={exceptionLeft}/>
    }

    const hideExceptionMessage = () => {
        setMessages([])
        setShowException(false)
    }

    if(props.summaryElement == null) {
        return null
    }

    return (
        <div onMouseLeave={() => hideExceptionMessage()} onBlur={() => hideExceptionMessage()}>

            <span>
                {props.element.elementKey + 1}. <b>{props.summaryElement.element_cat}</b> - {props.summaryElement.catalog_number}
            </span>
            { getFields() }
            { exceptionMessage() }
        </div>
    )
}

ElementModuleOptionsSelection.props = {
    element: PropTypes.object.isRequired,
    summaryElement: PropTypes.object.isRequired,
}
export default  ElementModuleOptionsSelection;